import { NewsSection } from "./news.section";
export default NewsSection;